import {
  columnCreatedAt,
  columnUpdatedAt,
} from '../../components/common';

export const columnName = {
  path: 'name', title: 'Name', sort: 'name', link: '/users/:_id',
};

export const columnEmail = 'email';

export const columnRole = 'role';

export const columnActive = {
  path: 'active',
  title: 'Status',
  render: record => (record.active ? 'ACTIVE' : 'INACTIVE'),
};

export const ADMIN_ALL = [
  columnName,
  columnEmail,
  // columnRole,
  columnActive,
  columnUpdatedAt,
  columnCreatedAt,
];
